
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as adminYOVTcVN8uGxDD2RWTj4DZZ_ZaWHN3_JPAPLHLVoCvk4Meta } from "/opt/buildhome/repo/app/pages/admin.vue?macro=true";
import { default as indexBUquJ6FW9selPoMmXmiQ06xberjjtjDDexnQK6NGwH0Meta } from "/opt/buildhome/repo/app/pages/index.vue?macro=true";
import { default as about_45usSvydtyeXhL9YBnoEE7oVNXWwts8HWzKOKgP8Cleaum4Meta } from "/opt/buildhome/repo/app/pages/about-us.vue?macro=true";
import { default as servicesgteNbaGt7pGUYcVpmXzIsxpEgOtTOPJuERc6tnO5xPsMeta } from "/opt/buildhome/repo/app/pages/services.vue?macro=true";
import { default as contact_45usTJCLg08lzs6lf6TaJcoJJSjW4Wx5Of9tkU0_YYxo7WIMeta } from "/opt/buildhome/repo/app/pages/contact-us.vue?macro=true";
import { default as indexuCVQg0V6e2mtFt8_S_IPlDyJGzzuDgbLBFiN16iGtXMMeta } from "/opt/buildhome/repo/app/pages/case-studies/index.vue?macro=true";
import { default as _91vertical_93GzFkW9AIkqD_uB_Bbp7ViFZklU2G2banHH4wPhKnTKAMeta } from "/opt/buildhome/repo/app/pages/case-studies/[vertical].vue?macro=true";
import { default as component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "admin",
    path: "/admin",
    meta: adminYOVTcVN8uGxDD2RWTj4DZZ_ZaWHN3_JPAPLHLVoCvk4Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/app/pages/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/opt/buildhome/repo/app/pages/about-us.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/opt/buildhome/repo/app/pages/services.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/opt/buildhome/repo/app/pages/contact-us.vue")
  },
  {
    name: "case-studies",
    path: "/case-studies",
    component: () => import("/opt/buildhome/repo/app/pages/case-studies/index.vue")
  },
  {
    name: "case-studies-vertical",
    path: "/case-studies/:vertical()",
    component: () => import("/opt/buildhome/repo/app/pages/case-studies/[vertical].vue")
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/about",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/contact",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/contact-us.html",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/about-us.html",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/work/detail-work/sss-social-security-system-philippine/",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/work/telkomsel",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/work/sss",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/work/detail-work/telkomsel/",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/work/pakdok",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/work/detail-work/pakdok/",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/works",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/index.html",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/case-studies/finance",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/case-studies/telecommunication",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/tentang-kami",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus/logistik",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/kontak-kami",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus/otomotif",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus/kesehatan",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/layanan",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus/keuangan",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus/pemerintah",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus/pendidikan",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus/pertambangan",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  },
  {
    name: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJoMeta?.name,
    path: "/studi-kasus/telekomunikasi",
    component: component_45stub_0o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_sPiDJo
  }
]